export enum WorkspaceBillingFeatures {
  WORKSPACE_AI = 'workspace.ai',
  WORKSPACE_INTEGRATIONS_OTEL = 'workspace.integrations.otel',
  WORKSPACE_PROJECTS_COUNT = 'workspaces.projects.count',
  WORKSPACE_USERS_COUNT = 'workspaces.users.count',
  WORKSPACE_PLATFORMS_COUNT = 'workspaces.projects.platforms.count'
}
